import { useAppSelector } from "hooks/redux";
import React from "react";
import GetStarted from "./GetStarted";
import "./loyalty.scss";
import LoyaltyProgramEdit from "./LoyaltyProgramEdit";


export default function LoyaltyProgram() {
    const {facilityStore} = useAppSelector(store => store);
    return (
        <>
        {!facilityStore?.loyaltyProgram ? (
            <GetStarted />
        ) : <LoyaltyProgramEdit/>}
        </>
    );
}